import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
// import { ReserveProvider } from '../../providers/reserve/reserve';
// import { LocationsProvider } from '../../providers/locations/locations';
// import { ConfigProvider } from '../../providers/config/config';
// import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
// import { ModalController } from 'ionic-angular/components/modal/modal-controller';
// import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { CoReserveComponent } from '../../components/co-reserve/co-reserve';
import { AppScreen } from '../../providers/config/config';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
/**
 * Generated class for the ReservePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve',
  templateUrl: 'reserve.html',
})
export class ReservePage {
  // allRooms: any;
  // unfiliteredRoomList: any;
  // allLocations: any;
  // allReservations: any;
  // builtLocationsForPage: any;
  // currentDay: any;
  // finalArray: any;
  // currentCart: any = [];
  // clientKeyword: any;
  // timezoneOffset: any;
  // locationsById: any;
  // realLocationById: any;
  viewType: string;
  // reserveFilters: any = {};
  // filterParameters: any = { tracker: false };
  // isFilterActive: any = {};
  // stickyHeader: any;
  // elementTop: number;
  // documentElement: any;
  // cardStyle: string;
  // densitySwitches: any;
  menuSide: string = "left";
  private clock: boolean;
  private screenData: AppScreen;
  isRootPage: boolean = false;
  enableBackButton: boolean = true;
  @ViewChild(CoReserveComponent) innerComponent: CoReserveComponent;

  constructor(private state: AppState, private navCtrl : NavController, private navParams : NavParams, private toast: ToastAlertsProvider) {
    // this.getAllRooms();
    // this.getAllLocations();
    this.screenData = this.navParams.data.screenData;
    this.clock = this.state.clockEnabledOnScreen;
    this.viewType = this.state.mode;
    this.navCtrl.length() <= 1 ? this.isRootPage = true : this.isRootPage = false;
    this.navCtrl.length() <= 0 ? this.enableBackButton = false : this.enableBackButton = true;
    // this.currentDay = moment().toString();
    // clientDetails.load().then((res) => {
    //   this.clientKeyword = res.keyword;
    //   this.timezoneOffset = res.timezone[0].offset;
    // });
    // this.getAllReservations();
    // this.cardStyle = "standard";
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
  }

  async ionViewCanLeave() {
    if(this.innerComponent.currentCart && this.innerComponent.currentCart.length > 0) {
      const res = await this.toast.showGenericConfirm('You have unsaved bookings, do you still want to leave?');
      if(!res) return false;
    }
    return true;
  }

  // goBack() {
  //   this.navCtrl.pop();
  // }

  onScroll(event) {
    this.innerComponent.onScroll(event);
  }

  // async getAllRooms() {
  //   let loader = this.loading.create();

  //   loader.present();
  //   await this.reserveProvider.getAllRooms().then((res) => {
  //     this.allRooms = res;
  //     this.unfiliteredRoomList = res;
  //     this.createRoomListForPage(res);
  //   });

  //   loader.dismiss();
  // };

  // async getAllReservations() {
  //   await this.reserveProvider.getReservations(moment(this.currentDay).startOf('day').format('YYYY-MM-DD HH:mm:ss').toString(), moment(this.currentDay).endOf('day').format('YYYY-MM-DD HH:mm:ss').toString()).then((res) => {
  //     this.allReservations = res;
  //   });

  //   return this.allReservations
  // }

  // createRoomListForPage(rawRoomsList) {
  //   let roomsObject;
  //   roomsObject = rawRoomsList.reduce((red, room) => {
  //     // let locationId = ;
  //     if (!red[room.locationId]) {
  //       red[room.locationId] = [];
  //     }
  //     red[room.locationId].push(room);
  //     return red;
  //   }, {});

  //   this.finalArray = Object.keys(roomsObject).map((key) => {
  //     return {
  //       rooms:roomsObject[key],
  //       branchName:  this.realLocationById[key].name,
  //       hours:  this.realLocationById[key].locationHours,
  //     }
  //   });
  // }

  // goToRoomDetails(room) {
  //   this.config.load(this.state.appId).then(cfg => {
  //     this.navCtrl.push(CoRoomDetailsPage, { room: room, currentDay: this.currentDay, previousView: this, locations: this.locationsById });
  //   });
  // }

  // getAllLocations() {
  //   this.locationProvider.getLocationsForPopover().then((res) => {
  //     this.allLocations = res;
  //     this.locationsById = [];
  //     this.realLocationById = {};
  //     this.allLocations.find((res) => {
  //       this.locationsById.push(res);
  //       this.realLocationById[res.id]=res;
  //     });
  //     // this.toggleView();
  //   });
  // };

  // applyReserveSidebarFilters(event) {
  //   this.reserveFilters[event.type] = event.stats;
  //   this.filterByPopOver(this.reserveFilters);
  // }

  // presentPopover(myEvent, filterParams) {
  //   let customClass = '';
  //   this.viewType === 'app' ? customClass = 'custom-popover-app' : customClass = 'custom-popover-desktop';
  //   let popover = this.popoverCtrl.create(CoPopoverReserveFilterComponent, { data: filterParams, current: this.filterParameters }, { cssClass: customClass });
  //   popover.present({
  //     ev: myEvent
  //   });

  //   popover.onDidDismiss(data => {
  //     if (data) {
  //       if (data.type != 'resetAll') {
  //         this.filterParameters.tracker = true;
  //         this.filterParameters[data.type] = data.stats;
  //         this.isFilterActive[data.type] = data.on;
  //         this.reserveFilters = this.filterParameters;
  //         let filters = this.filterParameters;
  //         this.filterByPopOver(this.reserveFilters);

  //       } else if (data.type === 'resetAll') {
  //         this.filterParameters = { tracker: true };
  //         let filters = this.filterParameters;
  //         this.reserveFilters = this.filterParameters;
  //         for (let key in this.isFilterActive) {
  //           this.isFilterActive[key] = false;
  //         };
  //         this.filterByPopOver(filters)

  //       } else {
  //         console.log('something bad happened');
  //       };
  //     }
  //   });
  // }

  // filterByPopOver(filterObj) {
  //   let filterByType;
  //   var filter = filterObj
  //   filterByType = this.allRooms.filter((room, i) => {
  //     for (var key in filter) {
  //       switch (key) {
  //         case ("time"):
  //           console.log('the filter', this.innerCards[i])
  //           // if (!this.innerCards[i].timelineArrayForFilterCheck[filter.time.upper * 4] || !this.innerCards[i].timelineArrayForFilterCheck[filter.time.lower * 4]){
  //           //   return false
  //           // }
  //           break;
  //         case ("location"):
  //           if (!filter.location.includes(room.locationId.toString())) {
  //             return false
  //           }
  //           break;
  //         case ("keyword"):
  //           let roomName = (room.name && room.name.length > 0) ? room.name.toLowerCase() : "";
  //           let roomTitle = (room.title && room.title.length > 0) ? room.title.toLowerCase() : "";

  //           if (roomName.indexOf(filterObj.keyword) === -1 && roomTitle.indexOf(filterObj.keyword) === -1) {
  //             return false;
  //           }
  //           break;
  //       }
  //     }
  //     return true;
  //   });
  //   this.createRoomListForPage(filterByType);
  // }

  // async previousDay() {
  //   let loader = this.loading.create();

  //   loader.present();
  //   this.currentDay = moment(this.currentDay).subtract(1, 'day').toString();

  //   let newReservations = await this.getAllReservations();
  //   await this.innerCards.forEach(element => {
  //     element.initializeCard(this.currentDay, newReservations);
  //   });
  //   loader.dismiss();
  // }

  // async nextDay() {
  //   let loader = this.loading.create();

  //   loader.present();
  //   this.currentDay = moment(this.currentDay).add(1, 'day').toString();

  //   let newReservations = await this.getAllReservations();
  //   await this.innerCards.forEach(element => {
  //     element.initializeCard(this.currentDay, newReservations);
  //   });
  //   loader.dismiss();
  // }

  // async goToDate(date) {
  //   let loader = this.loading.create();

  //   loader.present();
  //   this.currentDay = date;
  //   let newReservations = await this.getAllReservations();
  //   await this.innerCards.forEach(element => {
  //     element.initializeCard(this.currentDay, newReservations);
  //   });
  //   loader.dismiss();
  // }

  // async setCurrentDate(date) {
  //   let loader = this.loading.create();

  //   loader.present();
  //   this.currentDay = date;

  //   let newReservations = await this.getAllReservations();
  //   await this.innerCards.forEach(element => {
  //     element.initializeCard(this.currentDay, newReservations);
  //   });
  //   loader.dismiss();
  // }

  // openCalendar(event) {
  //   let popover = this.popoverCtrl.create(CoReserveCalendarComponent, { reservePage: this, currentDay: this.currentDay }, { cssClass: 'reserve-calendar-popover' });
  //   popover.present({
  //     ev: event
  //   });

  // }

  // goToCart(event, checkout: boolean) {
  //   if (this.state.mode === "app" && !checkout) {
  //     let modal = this.modalCtrl.create(CoCartPage, { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: false, popover: false });
  //     modal.present();
  //   }
  //   else if (this.state.mode === "app" && checkout) {
  //     let modal = this.modalCtrl.create(CoCartPage, { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false });
  //     modal.present();
  //   }
  //   else if (this.state.mode === "desktop" && !checkout) {
  //     let popover = this.popoverCtrl.create(CoCartPage, { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: false, popover: true }, { cssClass: 'custom-cart-popover' });
  //     popover.present({
  //       ev: event
  //     });
  //   }
  //   else if (this.state.mode === "desktop" && checkout) {
  //     let modal = this.modalCtrl.create(CoCartPage, { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false });
  //     modal.present();
  //   }



  // }

  // addToCart(booking) {
  //   this.currentCart.push(booking);
  // }

  // emptyCart() {
  //   this.currentCart = [];
  // }

  // toggleView(standard, event) {
  //   // let containers = Array.from(document.querySelectorAll(".anotherTimelineContainer"));
  //   // containers.forEach(element => {
  //   //   // element.classList.toggle('expandWidth');
  //   // });
  //   if (!this.densitySwitches) {
  //     this.densitySwitches = Array.from(event.target.parentElement.children);
  //   }

  //   this.densitySwitches.forEach(element => {
  //     element.classList.remove('nonActive');
  //   });

  //   if (!standard) {
  //     this.densitySwitches[0].classList.add('nonActive');
  //     this.cardStyle = "tablet";

  //   } else if (standard) {
  //     this.densitySwitches[1].classList.add('nonActive');
  //     this.cardStyle = "standard";
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/reserve/reserve.ts